const vacanciesConstants = {
  GET_VACANCIES_REQUEST: 'GET_VACANCIES_REQUEST',
  GET_VACANCIES_SUCCESS: 'GET_VACANCIES_SUCCESS',
  GET_VACANCIES_FAILURE: 'GET_VACANCIES_FAILURE',
};

export default vacanciesConstants;